/* eslint-disable no-nested-ternary */
/** 该文件夹下的其他目录没用到了 ，可删 */
import React, { useRef, useEffect, useState, useMemo, useCallback } from 'react';
import '@/pages/intelligence/assets/scss/TopCharts/MobileGames/components/Stats.scss';
import { Segment } from 'tea-component';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { useDispatch, history, connect, getLocale } from 'umi';
import {
  getStatsPageLogMes,
  getCountroesPageLogMes,
} from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
// import NewzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
import newzooWhite from '@/pages/intelligence/assets/svg/dataSource/action-theme.svg';
// import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/newzoo-bg.svg';
import NewzooIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import SelectChoice from '@/pages/intelligence/components/SelectCompoenet/SelectChoice';
import IconDom from '@/pages/intelligence/components/SelectCompoenet/ItemDom/IconDom';
// Famitsu is temporarily unavailable in PC&Console.
// import JapanSalesicon from '@/pages/intelligence/assets/svg/dataSource/japanSales.svg';
// import JapanSales from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/JapanSales';
import NewzooMetrics from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/NewzooMetrics';
import {
  steamPCUFollowerList,
  steamPCUList,
  steamSalesDetailList,
  newzooMetricsDetail,
  steamFollowersListForSteamData,
  sourceSteamFollowersList,
  alineaSalesDetailList,
  alineaMetricList,
  alineaPCUList,
  alineaFollowersList,
  sourceSteamList,
  steamPCUFollowerListForSteamData,
  pcConsoleDataList,
  pcConsoleAlineaStatsDetailList,
  pcConsoleAlineaCountriesStatsDetailList,
  pcConsoleGamalyticStatsDetailList,
  pcConsoleGamalyticCountriesStatsDetailList,
} from '@/pages/intelligence/pages/TopCharts/_config/metricOptions';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import VginsightsIcon from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
import SteamSales from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/SteamSales/Page';
import ConsoleData from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/ConsoleData';
import {
  CONSOLE_DATA_DEFAULT_METRIC,
  CONSOLE_DATA_COUNTRIES_DEFAULT_METRIC,
  CONSOLE_DATA_PS_PLAYERS_BY_COUNTRY,
  CONSOLE_DATA_SEGMENT,
} from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/ConsoleData/_config';
import { DETAIL_PAGEID } from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/_config';
import AllMetrics from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/AllMetrics';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';
import { LANGUAGE_CN } from '@home/_config/config';
import DigitalRevenue from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/DigitalRevenue';
import PhysicalRevenue from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/PhysicalRevenue';
import GSDData from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/GSDData';
import PCU from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/PCUPhysicalDigital/Pages/PCU';
import GSDIcon from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import useGSDOptions from '@intelligence/pages/TopCharts/_hooks/useGSDOptions';
// Famitsu is temporarily unavailable in PC&Console.
// import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { getIfShowSourceExplanation } from '@/pages/intelligence/utils/topchartsUtils';
import UserEngagementAmpere from '@intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/UserEngagementAmpere';
import { ampereMetricOptions } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/KPITrends/components/MetricsSelection/config';
import ampereWhite from '@/pages/intelligence/assets/svg/dataSource/ampere-bg-small.svg';
import DataSourceExplanation from '@intelligence/v3/components/DataSourceExplanation';
import { DATASOURCE_EXPLANATION_HTML_DATASOURCE_LIST, getDataSourceExplanationHtmlContent } from './utils/dataSourceExplanationHtmlConfig';
import InfoDocEN from '@intelligence/_locales/en-US';
import InfoDocCN from '@intelligence/_locales/zh-CN';
import { orderPCConsoleMetrics } from '@/pages/intelligence/pages/TopCharts/_config/pcConsoleMetricOrdering';

const ALINEA_ACTIVE_USER_METRIC_VALUES = ['alinea__dau', 'alinea__mau'];
const alineaActiveUserMetricsForSteam = alineaMetricList.filter((item) =>
  ALINEA_ACTIVE_USER_METRIC_VALUES.includes(item?.value),
);

const alineaSteamMetricList = [
  ...alineaPCUList,
  ...alineaFollowersList,
  ...alineaSalesDetailList,
  ...alineaActiveUserMetricsForSteam,
];

const normalizeDateType = (dateType = '') => {
  const dateTypeMap: Record<string, string> = {
    day: 'daily',
    date: 'daily',
    daily: 'daily',
    week: 'weekly',
    weekly: 'weekly',
    month: 'monthly',
    monthly: 'monthly',
  };
  return dateTypeMap[dateType] || dateType;
};

const filterMetricsByDateType = (list: any[] = [], dateType = '') => {
  const dateTypeCur = normalizeDateType(dateType);
  return list.filter((item) => {
    if (!Array.isArray(item?.dateEnum) || item.dateEnum.length < 1) return true;
    return item.dateEnum.includes(dateTypeCur);
  });
};

const getMetricDateType = (metric: string) => {
  const metricOption = alineaActiveUserMetricsForSteam.find((item) => item.value === metric);
  return metricOption?.dateEnum?.[0] || '';
};

const STATS_STEAM_ALINEA_WISHLISTS_BY_COUNTRY = 'alinea__wishlists_by_country';
const STATS_STEAM_INVALID_SUB_SEGMENT = STATS_STEAM_ALINEA_WISHLISTS_BY_COUNTRY;
const STATS_STEAM_FALLBACK_SUB_SEGMENT = 'alinea__players_by_country';
export default function PCConsoleStats(props: any) {
  const {
    gameId,
    tabType = '',
    activeId,
    entityType,
    moduleName,
    activeSegment,
    setActiveSegment,
    // hasJapanSales,
    hasSteamData,
    getRadioOptionsTips,
  } = props;

  const locale = getLocale();
  const isCN = locale === LANGUAGE_CN;

  const isStats = tabType === 'stats';
  const isCountries = tabType === 'countries';

  // 数据源解释说明卡片展开/折叠按钮
  const dataSourceExplanationTrigger = useRef<HTMLElement>();
  // 数据源解释说明卡片内容
  const dataSourceExplanationBody = useRef<HTMLElement>();

  // console.log('PCConsoleStats', props);
  // Famitsu is temporarily unavailable in PC&Console.
  // const { resetDetailFilterExtend } = useFilterExtend({});
  const [steamSalesDateType, setSteamSalesDateType] = useState<string>(
    () => getMetricDateType(activeSegment) || 'monthly',
  );
  const getSubSteamDataListByDateType = useCallback(
    (dateType = '') => {
      const alineaSteamMetrics = filterMetricsByDateType(
        isCountries ? pcConsoleAlineaCountriesStatsDetailList : pcConsoleAlineaStatsDetailList,
        dateType,
      );
      const gamalyticSteamMetrics = isCountries
        ? pcConsoleGamalyticCountriesStatsDetailList
        : pcConsoleGamalyticStatsDetailList;

      // PC&Console 移除 VGI Steam Weighted Price
      const metricsList = isCountries
        ? [
          ...sourceSteamList,
          ...alineaSteamMetrics,
          ...gamalyticSteamMetrics,
          ...steamPCUList,
          ...steamSalesDetailList?.filter((item) => item.value !== 'weighted_price'),
        ]
        : [
          ...sourceSteamList,
          ...sourceSteamFollowersList,
          ...alineaSteamMetrics,
          ...gamalyticSteamMetrics,
          ...steamFollowersListForSteamData.filter((item) => item.value !== 'steamfollowers'),
          ...steamSalesDetailList,
        ];

      return orderPCConsoleMetrics(metricsList, 'displaySource');
    },
    [isCountries, isStats],
  );

  const newSteamSaleList = useMemo(() => {
    const alineaSteamMetrics = [
      ...(isCountries ? pcConsoleAlineaCountriesStatsDetailList : pcConsoleAlineaStatsDetailList),
    ];
    const gamalyticSteamMetrics = isCountries ? pcConsoleGamalyticCountriesStatsDetailList : pcConsoleGamalyticStatsDetailList;

    return orderPCConsoleMetrics([
      ...sourceSteamList,
      ...steamPCUFollowerListForSteamData,
      ...alineaSteamMetrics,
      ...gamalyticSteamMetrics,
      ...steamSalesDetailList,
    ], 'displaySource');
  }, [isCountries]);

  const subSteamDataList = useMemo(
    () => getSubSteamDataListByDateType(steamSalesDateType),
    [getSubSteamDataListByDateType, steamSalesDateType],
  );
  const alineaSteamMetricsByDateType = useMemo(
    () => filterMetricsByDateType(alineaSteamMetricList, steamSalesDateType),
    [steamSalesDateType],
  );
  const alineaMetricsList = useMemo(
    () => [...alineaSteamMetricsByDateType, ...pcConsoleDataList],
    [alineaSteamMetricsByDateType],
  );
  const subOptionsList = {
    newzooMetrics: { list: newzooMetricsDetail, svg: NewzooIcon },
    steamSales: { list: subSteamDataList, svg: VginsightsIcon },
    [CONSOLE_DATA_SEGMENT]: { list: alineaMetricsList, svg: getDataSourceIcon('alinea') },
    ampere: { list: ampereMetricOptions, svg: getDataSourceIcon('ampere') },
  } as any;

  const subNewzooValues = newzooMetricsDetail?.map((item: any) => item.value);
  const subSteamSalesValues = useMemo(
    () => subSteamDataList?.map((item: any) => item.value),
    [subSteamDataList],
  );
  const subConsoleDataValues = useMemo(() => {
    const baseValues = pcConsoleDataList?.map((item: any) => item.value) || [];
    if (isStats) {
      return alineaMetricsList.map((item: any) => item.value);
    }
    return isCountries
      ? [CONSOLE_DATA_PS_PLAYERS_BY_COUNTRY, ...baseValues]
      : baseValues;
  }, [alineaMetricsList, isCountries, isStats]);
  const subUserEngagementAmpereValues = ampereMetricOptions?.map(
    (item: any) => item.value,
  );

  const { formatMessage } = useIntlExtend();

  const {
    // GSD options集合 接口loading
    loading: gsdOptionsLoading,
    // GSD segment的options集合
    segments: gsdSegments,
    // GSD device的options集合（级联）
    combineDevices: gsdDevices,
    // GSD device的options集合（扁平化）
    combineDevicesFlatten: gsdDevicesFlatten,
  } = useGSDOptions();

  const commonMainOption = [
    {
      text: formatMessage({ id: `dbi_metric_steamdata` }),
      value: 'steamSales',
      svg: getDataSourceIcon('steam'),
    },
    {
      text: formatMessage({ id: `dbi_digital_revenue` }),
      value: 'digitalRevenue',
      svg: MscienceIcon,
    },
    {
      text: formatMessage({ id: `dbi_combine_console_data` }),
      value: CONSOLE_DATA_SEGMENT,
      svg: getDataSourceIcon('alinea'),
    },
    {
      text: formatMessage({ id: `dbi_metric_gsd_sales_date` }),
      value: 'gsd',
      svg: GSDIcon,
    },
    {
      text: formatMessage({ id: `dbi_physical_revenue` }),
      value: 'physicalRevenue',
      svg: Npdicon,
    },
    // Famitsu is temporarily unavailable in PC&Console.
    // {
    //   text: formatMessage({ id: `dbi_japan_sales` }),
    //   value: 'japanSales',
    //   svg: JapanSalesicon,
    // },
    {
      text: formatMessage({ id: `dbi_newzoo_metrics` }),
      value: 'newzooMetrics',
      svg: NewzooIcon,
    },
  ];

  // 国家页面单独的tab配置项，可独立调整顺序，不影响stats页面
  const commonMainOption_pcConsole_countries = [
    {
      text: formatMessage({ id: `dbi_metric_steamdata` }),
      value: 'steamSales',
      svg: getDataSourceIcon('steam'),
    },
    {
      text: formatMessage({ id: `dbi_ampere_metrics` }),
      value: 'ampere',
      svg: getDataSourceIcon('ampere'),
    },
    {
      text: formatMessage({ id: `dbi_digital_revenue` }),
      value: 'digitalRevenue',
      svg: MscienceIcon,
    },
    {
      text: formatMessage({ id: `dbi_combine_console_data` }),
      value: CONSOLE_DATA_SEGMENT,
      svg: getDataSourceIcon('alinea'),
    },
    {
      text: formatMessage({ id: `dbi_metric_gsd_sales_date` }),
      value: 'gsd',
      svg: GSDIcon,
    },
    {
      text: formatMessage({ id: `dbi_physical_revenue` }),
      value: 'physicalRevenue',
      svg: Npdicon,
    },
    {
      text: formatMessage({
        id: `dbi_metric_no_update`,
      }),
      value: 'newzooMetrics',
      svg: NewzooIcon,
    },
  ];

  const allMetricsMainOption = [
    {
      text: formatMessage({ id: `dbi_all_metrics` }),
      value: 'allMetrics',
    },
  ];

  const optionsDom = useMemo(() => {
    let arrList: any = [];
    if (isStats) {
      arrList = [...allMetricsMainOption, ...commonMainOption];
    } else if (isCountries) {
      arrList = commonMainOption_pcConsole_countries;
    }

    return arrList
      ?.filter((item: any) => {
        // Famitsu is temporarily unavailable in PC&Console.
        // if (!hasJapanSales) {
        //   return item.value !== 'japanSales';
        // }
        if (!hasSteamData) {
          return item.value !== 'steamSales';
        }
        if (!isStats) {
          return item.value !== 'allMetrics';
        }

        return true;
      })
      ?.map((item: any) => ({
        value: item.value,
        text: <IconDom data={item} />,
      }));
  }, [locale, isStats, isCountries, hasSteamData]);

  const mainOptionsValues = useMemo(
    () => optionsDom?.map((item: any) => item.value),
    [optionsDom],
  );

  // 根据当前选中指标指定当前选中 segment
  const getMainSegment = (activeSegment: string, preferredMainSegment?: string) => {
    if (
      preferredMainSegment === CONSOLE_DATA_SEGMENT &&
      subConsoleDataValues?.includes(activeSegment)
    ) {
      return CONSOLE_DATA_SEGMENT;
    }
    if (
      preferredMainSegment === 'steamSales' &&
      subSteamSalesValues?.includes(activeSegment)
    ) {
      return 'steamSales';
    }
    if (subNewzooValues?.includes(activeSegment)) {
      return 'newzooMetrics';
    }
    if (
      activeSegment === CONSOLE_DATA_SEGMENT ||
      subConsoleDataValues?.includes(activeSegment)
    ) {
      return CONSOLE_DATA_SEGMENT;
    }
    if (subSteamSalesValues?.includes(activeSegment)) {
      return 'steamSales';
    }
    if (isCountries && subUserEngagementAmpereValues?.includes(activeSegment)) {
      return 'ampere';
    }
    return mainOptionsValues?.includes(activeSegment) ? activeSegment : mainOptionsValues[0];
  };

  // 国家页面默认子指标：Alinea Steam Players by Country
  const DEFAULT_COUNTRIES_SUB_SEGMENT = 'alinea__players_by_country';

  const getCountriesSubSegment = (segment: string, currentMainSegment: string) => {
    if (
      isCountries &&
      currentMainSegment === 'steamSales' &&
      !subSteamSalesValues?.includes(segment)
    ) {
      return DEFAULT_COUNTRIES_SUB_SEGMENT;
    }
    if (
      isCountries &&
      currentMainSegment === CONSOLE_DATA_SEGMENT &&
      !subConsoleDataValues?.includes(segment)
    ) {
      return CONSOLE_DATA_COUNTRIES_DEFAULT_METRIC;
    }
    return segment;
  };

  const initMainSegment = getMainSegment(activeSegment);
  // 国家页面进入 Steam Data 时，如果 URL/上个页签没有可用子指标，默认选中 Players by Country
  const initSubSegment = getCountriesSubSegment(activeSegment, initMainSegment);


  const [mainSegment, setMainSegment] = useState<string>(initMainSegment);
  const [subSegment, setSubSegment] = useState<string>(initSubSegment);
  // const [activeSegment, setUrlTab] = useState(activeSegment);
  const [loading, setLoading] = useState(true); // 用于给segment, loading时禁用， 也可以存在model中
  const [destroyed, setDestroyed] = useState(false);

  const dispatch = useDispatch();
  const invalidSteamSegmentRedirectedRef = useRef(false);
  const pageLogKeyRef = useRef('');

  useEffect(() => {
    pageLogKeyRef.current = '';
  }, [gameId]);

  const changeUrl = useCallback(
    (activeSubTab: string) => {
      const newPath = `/intelligence/topCharts/${moduleName || 'pcConsoleGames'}/gamesDetails/${gameId}/${activeId}/${activeSubTab}`;
      // 只在路径真正变化时才更新 URL，避免 replaceState 超限
      if (window.location.pathname !== newPath) {
        history.replace(newPath);
      }
    },
    [activeId, gameId, moduleName],
  );

  useEffect(() => {
    // originalStats / Steam Data：页面指标筛选器不含 alinea__wishlists_by_country，旧 URL 仅改路由，由父级从 params 同步 activeSegment
    if (
      isStats &&
      activeSegment === STATS_STEAM_INVALID_SUB_SEGMENT &&
      !subSteamSalesValues?.includes(STATS_STEAM_INVALID_SUB_SEGMENT)
    ) {
      const fallbackSubSegment = subSteamSalesValues?.includes(
        STATS_STEAM_FALLBACK_SUB_SEGMENT,
      )
        ? STATS_STEAM_FALLBACK_SUB_SEGMENT
        : subSteamSalesValues?.[0];
      if (fallbackSubSegment && !invalidSteamSegmentRedirectedRef.current) {
        invalidSteamSegmentRedirectedRef.current = true;
        changeUrl(fallbackSubSegment);
      }
      return;
    }

    if (activeSegment !== STATS_STEAM_INVALID_SUB_SEGMENT) {
      invalidSteamSegmentRedirectedRef.current = false;
    }

    const _mainSegment = getMainSegment(activeSegment, mainSegment);
    setMainSegment(_mainSegment);

    let nextSubSegment = getCountriesSubSegment(activeSegment, _mainSegment);

    // Stats（originalStats）：处于 All Metrics 主 Tab 且无 URL segment 时，与「…/originalStats/allMetrics」对齐，
    // 避免 subSegment 长期为空导致详情参数与 KPI Trends All Metrics 不一致（含下载弹窗指标默认回显）。
    if (isStats && _mainSegment === 'allMetrics' && !nextSubSegment) {
      nextSubSegment = 'allMetrics';
    }

    if (isStats && _mainSegment === CONSOLE_DATA_SEGMENT) {
      if (!subConsoleDataValues?.includes(nextSubSegment)) {
        nextSubSegment = CONSOLE_DATA_DEFAULT_METRIC;
      }
    }

    if (isCountries && _mainSegment === CONSOLE_DATA_SEGMENT) {
      if (!subConsoleDataValues?.includes(nextSubSegment)) {
        nextSubSegment = CONSOLE_DATA_COUNTRIES_DEFAULT_METRIC;
      }
    }

    setSubSegment(nextSubSegment);

    if (
      isStats &&
      _mainSegment === 'allMetrics' &&
      !activeSegment &&
      nextSubSegment === 'allMetrics'
    ) {
      changeUrl('allMetrics');
    }

    if (
      isStats &&
      _mainSegment === CONSOLE_DATA_SEGMENT &&
      (!activeSegment || activeSegment === CONSOLE_DATA_SEGMENT)
    ) {
      changeUrl(nextSubSegment);
    }

    if (
      isCountries &&
      _mainSegment === CONSOLE_DATA_SEGMENT &&
      (!activeSegment || activeSegment === CONSOLE_DATA_SEGMENT)
    ) {
      changeUrl(nextSubSegment);
    }

    handlePageLog(_mainSegment, gameId);
  }, [
    activeSegment,
    subSteamSalesValues,
    subConsoleDataValues,
    mainSegment,
    isCountries,
    isStats,
    gameId,
    changeUrl,
  ]);

  const optionsDomTemp = useMemo(() => {
    let arrList: any = [];
    if (isStats) {
      arrList = [...allMetricsMainOption, ...commonMainOption];
    } else if (isCountries) {
      arrList = commonMainOption_pcConsole_countries;
    }
    return arrList
      ?.filter((item: any) => {
        // Famitsu is temporarily unavailable in PC&Console.
        // if (!hasJapanSales) {
        //   return item.value !== 'japanSales';
        // }
        if (!hasSteamData) {
          return item.value !== 'steamSales';
        }
        if (tabType !== 'stats') {
          return item.value !== 'allMetrics';
        }
        return true;
      })
      ?.map((item: any) => {
        let svgTemp = item?.svg;
        if (mainSegment === 'newzooMetrics' && item?.value === 'newzooMetrics') {
          svgTemp = newzooWhite;
        } else if (mainSegment === 'ampere' && item?.value === 'ampere') {
          svgTemp = ampereWhite;
        } else if (
          mainSegment === CONSOLE_DATA_SEGMENT &&
          item?.value === CONSOLE_DATA_SEGMENT
        ) {
          svgTemp = getDataSourceIcon('alineawhite');
        }
        const itemTemp = {
          ...item,
          svg: svgTemp,
        };
        return {
          value: item.value,
          text: <IconDom data={itemTemp} />,
        };
      });
  }, [optionsDom, mainSegment]);

  const handlePageLog = (tab: string, gameId: string) => {
    const pageLogKey = `${gameId}__${tab}`;
    if (pageLogKeyRef.current === pageLogKey) {
      return;
    }
    pageLogKeyRef.current = pageLogKey;

    const pageLogMes = isCountries ? getCountroesPageLogMes(entityType, tab) : getStatsPageLogMes(entityType, tab);
    if (gameId && pageLogMes) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的feedback参数
    recordPageMesForFeedback(pageLogMes);
  };

  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };

  const handleSteamSalesDateTypeChange = useCallback(
    (dateType = '') => {
      setSteamSalesDateType(dateType);

      const currentSubSegment = subSegment || activeSegment;
      if (!ALINEA_ACTIVE_USER_METRIC_VALUES.includes(currentSubSegment)) {
        return true;
      }

      const nextMetricList =
        mainSegment === CONSOLE_DATA_SEGMENT
          ? filterMetricsByDateType(alineaSteamMetricList, dateType)
          : getSubSteamDataListByDateType(dateType);
      const isCurrentMetricAvailable = nextMetricList.some(
        (item: any) => item?.value === currentSubSegment,
      );
      if (isCurrentMetricAvailable) {
        return true;
      }

      const defaultSteamSubSegment =
        mainSegment === CONSOLE_DATA_SEGMENT
          ? nextMetricList?.[0]?.value
          : isCountries
            ? DEFAULT_COUNTRIES_SUB_SEGMENT
            : sourceSteamList?.[0]?.value;
      const isDefaultMetricAvailable = nextMetricList.some(
        (item: any) => item?.value === defaultSteamSubSegment,
      );
      if (!defaultSteamSubSegment || !isDefaultMetricAvailable) {
        return true;
      }

      setSubSegment(defaultSteamSubSegment);
      setActiveSegment(defaultSteamSubSegment);
      changeUrl(defaultSteamSubSegment);
      return false;
    },
    [
      activeSegment,
      changeUrl,
      getSubSteamDataListByDateType,
      isCountries,
      mainSegment,
      setActiveSegment,
      subSegment,
    ],
  );

  const renderSubSegment = (mainSegment: string) => {
    // 获取对应 segment 的选项列表
    const subOption = subOptionsList[mainSegment];

    if (!Array.isArray(subOption?.list)) {
      return null;
    }

    const { svg } = subOption;
    const optionDom = subOption.list.map((item: any) => {
      const localeKey = item?.text || item?.value;
      return {
        value: item.value,
        searchText: [
          (InfoDocEN as any)?.[localeKey],
          (InfoDocCN as any)?.[localeKey],
          formatMessage({ id: localeKey }),
        ]
          .filter(Boolean)
          .join(' '),
        text: (
          <IconDom
            data={{
              ...item,
              text: formatMessage({ id: item.text }),
              svg: item?.icon ? getDataSourceIcon(item?.icon) : svg,
            }}
          />
        ),
      };
    });

    return (
      <SelectChoice
        className="dbi-stats-select-item"
        labelValue={formatMessage({ id: 'dbi_label_metrics' })}
        changeValue={subSegment}
        optionsList={optionDom}
        getSelectMultiple={(value: any) => {
          setSubSegment(value);
          handlePageLog(value, gameId);
          setActiveSegment(value);
          changeUrl(value);
        }}
        searchable={
          mainSegment === 'steamSales' ||
          mainSegment === CONSOLE_DATA_SEGMENT
        }
        searchPlaceholder={formatMessage({ id: 'dbi_label_search' })}
        autoClearSearchValue
        filter={(inputValue: string, option: any) =>
          option?.searchText
            ?.toLocaleLowerCase()
            .includes(inputValue.trim().toLocaleLowerCase())
        }
        listWidth={isCN ? 282 : 310}
      />
    );
  };
  // console.log(activeSegment, mainSegment, subSegment);
  const steamPCUPage =
    mainSegment === 'steamSales' &&
    steamPCUFollowerList?.map((t) => t?.value).includes(subSegment);
  const isAlineaSteamMetric =
    isStats &&
    alineaSteamMetricsByDateType.some((item: any) => item?.value === subSegment);
  const isSteamSalesPage =
    mainSegment === 'steamSales' ||
    (mainSegment === CONSOLE_DATA_SEGMENT && isAlineaSteamMetric);

  const PCUPhysicalDigitalComp =
    mainSegment === 'physicalRevenue'
      ? PhysicalRevenue
      : mainSegment === 'digitalRevenue'
        ? DigitalRevenue
        : mainSegment === 'gsd'
          ? GSDData
          : PCU;

  return (
    <div className="dbi-mobile-games-stats">
      <div className="mobile-games-flex" style={{ whiteSpace: 'nowrap' }}>
        <Segment
          className="segment-light games-left"
          value={mainSegment}
          onChange={(value) => {
            let activeSegmentForUrl = value;
            // 有子标签的需要设置默认值
            if (value === 'newzooMetrics') {
              setSubSegment(subNewzooValues[0]);
              activeSegmentForUrl = subNewzooValues[0];
            } else if (value === 'steamSales') {
              const defaultSteamSub = isCountries ? DEFAULT_COUNTRIES_SUB_SEGMENT : subSteamSalesValues[0];
              setSubSegment(defaultSteamSub);
              activeSegmentForUrl = defaultSteamSub;
            } else if (value === 'ampere') {
              setSubSegment(subUserEngagementAmpereValues[0]);
              activeSegmentForUrl = subUserEngagementAmpereValues[0];
            } else if (value === CONSOLE_DATA_SEGMENT) {
              const defaultConsoleMetric = isCountries
                ? CONSOLE_DATA_COUNTRIES_DEFAULT_METRIC
                : subConsoleDataValues?.[0] || CONSOLE_DATA_DEFAULT_METRIC;
              setSubSegment(defaultConsoleMetric);
              activeSegmentForUrl = defaultConsoleMetric;
            }
            // Famitsu is temporarily unavailable in PC&Console.
            // if (value === 'japanSales') {
            //   resetDetailFilterExtend();
            // }
            setActiveSegment(activeSegmentForUrl);
            setMainSegment(value);
            handlePageLog(value, gameId);
            setDestroyed(true);
            setTimeout(() => {
              setDestroyed(false);
            }, 0);
            changeUrl(activeSegmentForUrl);
          }}
          options={optionsDomTemp}
        />
        {getIfShowSourceExplanation(mainSegment) && (
          <div ref={dataSourceExplanationTrigger} className="dbi_pcconsole_source_explanation-div mobile-games-flex-right" />
        )}
      </div>
      {getIfShowSourceExplanation(mainSegment) && <div ref={dataSourceExplanationBody}></div>}

      {/* Famitsu is temporarily unavailable in PC&Console.
          Restore by replacing the steamSales branch below with:
          destroyed ? null : mainSegment === 'japanSales' ? (
            <JapanSales
              {...props}
              pageId={`${mainSegment}—${subSegment}`}
              tabType={tabType}
              loading={loading}
              setLoading={setLoading}
              mainSegment={mainSegment}
              subSegment={subSegment}
              gsdDevicesFlatten={gsdDevicesFlatten}
              gsdSegments={gsdSegments}
            />
          ) : mainSegment === 'steamSales' ? (
      */}
      {destroyed ? null : isSteamSalesPage ? (
        <SteamSales
          {...props}
          pageId={`steamSales—${subSegment}`}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment="steamSales"
          subSegment={subSegment}
          activeSegment={activeSegment}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
          newSteamSaleList={newSteamSaleList}
          onDateTypeChange={handleSteamSalesDateTypeChange}
        />
      ) : mainSegment === 'ampere' ? (
        // countries 页 ampere 数据 UserEngagementAmpere Segment
        <UserEngagementAmpere
          {...props}
          pageId={`${mainSegment}—${subSegment}`}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          hasDevice={true}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
          getRadioOptionsTips={getRadioOptionsTips}
        />
      ) : mainSegment === 'newzooMetrics' ? (
        <NewzooMetrics
          {...props}
          pageId={`${mainSegment}—${subSegment}`}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          hasDevice={true}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
        />
      ) : mainSegment === 'allMetrics' ? (
        <>
          <AllMetrics
            {...props}
            entityType={entityType}
            pageId={`${mainSegment}—${subSegment}`}
            tabType={tabType}
            loading={loading}
            setLoading={setLoading}
            mainSegment={mainSegment}
            gsdDevicesFlatten={gsdDevicesFlatten}
            gsdSegments={gsdSegments}
            subSegment={subSegment}
            getRadioOptionsTips={getRadioOptionsTips}
          />
        </>
      ) : mainSegment === CONSOLE_DATA_SEGMENT ? (
        <ConsoleData
          {...props}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={mainSegment}
          subSegment={subSegment}
          setActiveSegment={setActiveSegment}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdSegments={gsdSegments}
          filterLeftComp={isStats ? renderSubSegment(mainSegment) : undefined}
        />
      ) : (
        // digitalRevenue ,  physicalRevenue,
        <PCUPhysicalDigitalComp
          {...props}
          pageId={steamPCUPage ? DETAIL_PAGEID.pcu : mainSegment}
          tabType={tabType}
          loading={loading}
          setLoading={setLoading}
          mainSegment={steamPCUPage ? 'pcu' : mainSegment}
          subSegment={subSegment}
          steamPCUPage={steamPCUPage}
          activeSegment={activeSegment}
          gsdOptionsLoading={gsdOptionsLoading}
          gsdDeviceOptions={gsdDevicesFlatten}
          gsdDeviceCascaderOptions={gsdDevices}
          gsdSegmentOptions={gsdSegments}
          // activeSegment={steamPCUPage ? 'pcu' : activeSegment}
          gsdDevicesFlatten={gsdDevicesFlatten}
          gsdSegments={gsdSegments}
          filterLeftComp={renderSubSegment(mainSegment)}
        />
      )}
      {/* 数据源解说说明模块 */}
      {getIfShowSourceExplanation(mainSegment) && (
        <DataSourceExplanation
          domain="dbi_pcconsole_sourcelist_state"
          triggerBtnText={formatMessage({ id: 'dbi_pcconsole_source_explanation' })}
          dataSourceList={DATASOURCE_EXPLANATION_HTML_DATASOURCE_LIST}
          htmlContentMap={getDataSourceExplanationHtmlContent(locale)}
          trigger={dataSourceExplanationTrigger}
          body={dataSourceExplanationBody}
        />
      )}
    </div>
  );
}

connect((state: any) => ({
  topchartsState: state[DBI_TOPCHARTS],
}))(PCConsoleStats);
